import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getProjectScoreCardsSummary';

export const getProjectScoreCardsSummary = (params, endpoint = ENDPOINT) => {
    return network.post(endpoint, params).then((response) => {
        return response.data;
    });
};
